module.exports = __webpack_public_path__ + "img/ad5fa1a.jpg";